// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-popup-modal[data-v-7c504d0a]{position:relative}.login-popup-modal .icon-guanbi[data-v-7c504d0a]{position:absolute;top:30px;right:30px;z-index:1;cursor:pointer}", ""]);
// Exports
module.exports = exports;
